<template lang="pug">
    .carousel-all-ms
        carousel(:items="1", :dots="false", :nav="false", :loop="true", :autoplay="true", :autoplaySpeed="800", :rewind="true", :autoplayTimeout="7000")
            PmHomeSlider(:image="carouselImage3", :lenguage="lenguageSelected.sliderContent")
            PmHomeSlider(:image="carouselImage1", :lenguage="lenguageSelected.sliderContent")
            PmHomeSlider(:image="carouselImage2", :lenguage="lenguageSelected.sliderContent")

        section.md-section(style="background-color:#f7f7f7;padding:0;")
            .container(style="padding-bottom: 50px")
                .textbox-group
                    .row
                        PmHomeCard(:image="card1", :link="lenguageSelected.homeCard1.link", :lenguage="lenguageSelected.homeCard1")
                        PmHomeCard(:image="card2", :link="lenguageSelected.homeCard2.link", :lenguage="lenguageSelected.homeCard2")
                        PmHomeCard(:image="card3", :link="lenguageSelected.homeCard3.link", :lenguage="lenguageSelected.homeCard3")
        
        section.md-section.md-section-top(style="background-color:#f7f7f7;padding-top:0;")
            .container(style="padding-bottom: 160px;")
                .row
                    .col-md-12.col-lg-12.offset-0.offset-sm-0
                        .iconbox
                            div
                                h2.iconbox__title.iconbox__title-sub.set-sub-home(v-html="lenguageSelected.subHome", style="text-transform: inherit!important;")
                                .iconbox__description.iconbox__title-desc(style="color: #7d7d7d")
                                    | {{ lenguageSelected.subHomeDesc }}
                .row
                    PmHomeService(:image="service1", :lenguage="lenguageSelected.homeService1")
                    PmHomeService(:image="service2", :lenguage="lenguageSelected.homeService2")
                    PmHomeService(:image="service3", :lenguage="lenguageSelected.homeService3")
                    PmHomeService(:image="service4", :lenguage="lenguageSelected.homeService4")    

        section.md-section.md-section4(style="background-color:#56575b;padding-top:100px;padding-bottom:100px;")
            .container
                .row
                    .col-md-12.col-lg-12.offset-0.offset-sm-0
                        .md-section-3-title
                            | {{ lenguageSelected.homeSection3.title }}
                .row
                    .col-md-12.col-lg-12.offset-0.offset-sm-0
                        .md-section-3-subtitle
                            | {{ lenguageSelected.homeSection3.content }}
                .row
                    .col-md-12.col-lg-12.offset-0.offset-sm-0
                        .md-section-3-options  
                            router-link.md-section-3-option(v-for="option in lenguageSelected.homeSection3Options.options", :to="option.link")
                                span {{ option.name }}
        
        section.md-section.md-section4(style="background-color:#e2e9ec;padding-top:50px;padding-bottom:50px;")
            .container
                .row
                    .col-md-6.md-section4-images(:class="'md-section4-image-' + selectedCountry ")
                        img.is-colombia(:src="map_colombia")
                        img.is-peru(:src="map_peru")
                        img.is-chile(:src="map_chile")
                        img.is-ecuador(:src="map_ecuador")
                    .col-md-6.content-section-4
                        .md-section-4-title {{ lenguageSelected.homeSection4.title }}
                        .md-section-4-desc
                            p {{ lenguageSelected.homeSection4.content1 }}
                            p {{ lenguageSelected.homeSection4.content2 }}
                            p {{ lenguageSelected.homeSection4.content3 }}
                            p {{ lenguageSelected.homeSection4.content4 }}
                        .md-section-4-btns
                            .md-section-4-btn( @click="changeCountry('chile')", :class="{'active' : selectedCountry == 'chile'}") {{ lenguageSelected.homeSection4Options[0] }}
                            .md-section-4-btn( @click="changeCountry('colombia')", :class="{'active' : selectedCountry == 'colombia'}") {{ lenguageSelected.homeSection4Options[1] }}
                            .md-section-4-btn( @click="changeCountry('peru')", :class="{'active' : selectedCountry == 'peru'}") {{ lenguageSelected.homeSection4Options[2] }}
                            .md-section-4-btn( @click="changeCountry('ecuador')", :class="{'active' : selectedCountry == 'ecuador'}") {{ lenguageSelected.homeSection4Options[3] }}

</template>

<script>
import carousel from 'vue-owl-carousel'

import carouselImage1 from '@img/home/slider1.jpg'
import carouselImage2 from '@img/home/slider2.jpg'
import carouselImage3 from '@img/home/slider3.jpg'

import card1 from '@img/home/card1.jpg'
import card2 from '@img/home/card2.jpg'
import card3 from '@img/home/card3.jpg'

import map_chile from '@img/home/Mapa_Chile.png'
import map_colombia from '@img/home/Mapa_Colombia.png'
import map_peru from '@img/home/Mapa_Peru.png'
import map_ecuador from '@img/home/Mapa_Ecuador.png'

import service1 from '@img/home/WeLease_Over.png'
import service2 from '@img/home/WeBuild_Over.png'
import service3 from '@img/home/WeManage_Over.png'
import service4 from '@img/home/WeBuy_Over.png'

import PmHomeSlider from '@components/atoms/PmHomeSlider.vue'
import PmHomeCard from '@components/atoms/PmHomeCard.vue'
import PmHomeService from '@components/atoms/PmHomeService.vue'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    mounted: function(){
    let to = this.moveToDown
        ? this.$refs.description.offsetTop - 60
        : 0

    window.scroll({
        top: to,
        left: 0,
        behavior: 'smooth'
    })

    this.moveToDown = !this.moveToDown
    },
    components: { 
        carousel, PmHomeSlider, PmHomeCard, PmHomeService
    },
    methods: {
        changeCountry: function(data){
            this.$data.selectedCountry = data
            console.log(this.$data.selectedCountry)
        }
    },
    data: function(){
        return {
            selectedCountry: "colombia",

            carouselImage1: carouselImage1,
            carouselImage2: carouselImage2,
            carouselImage3: carouselImage3,

            card1: card1,
            card2: card2,
            card3: card3,

            service1: service1,
            service2: service2,
            service3: service3,
            service4: service4,

            map_chile: map_chile,
            map_colombia: map_colombia,
            map_peru: map_peru,
            map_ecuador: map_ecuador,

            lenguage: 'ES',
            
            lenguageEN: {
                sliderContent: {part1: 'Welcome to', part2: 'Andean Telecom Partners', part3: 'Comprehensive Digital Infrastructure'},
                homeCard1: {link: '/en/products/towers-and-rooftops',title: 'Towers & Microsites', content:'We build, own, acquire, manage, and lease vertical assets to telecommunications carriers and other wireless technology providers.'},
                homeCard2: {link: '/en/products/optical-fiber',title: 'Optical Fiber', content: 'We have launched optical fiber business operations across the region. We build, own, acquire, manage, and lease shared fiber networks to meet the capacity and densification needs of data service providers.'},
                homeCard3: {link: '/en/products/small-cells',title: 'Small Cells & DAS', content: 'We build, own, acquire, manage, and lease  indoor and outdoor small cell service solutions. We are successfully executing small cell deployment projects across Colombia, Peru, Chile and Ecuador, as mobile network operators densify their networks. '},
                subHome: 'Leading Provider of <b> Converged Infrastructure Services </b> for Advanced Network Connectivity',
                subHomeDesc: 'Wireless operators, broadcasters and real estate companies across the Andean region rely on ATP and our team of industry experts for network expansion and densification. If you want to expand or densify your network, we can help.',
                homeService1: {name: "We Lease", link: "/en/services/we-lease", subtitle: "Site Leasing", description: 'With thousands of owned and managed sites across the Andean region, we offer carriers the variety of locations and solutions needed to reach their most important customers.'},
                homeService2: {name: "We Build", link: "/en/services/we-build", subtitle: "Site & Network Development", description: 'We have established a strong track record for delivering projects on time, and on budget.'},
                homeService3: {name: "We Manage", link: "/en/services/we-manage", subtitle: "Property, Buildings, City Infrastructure and Rooftops", description: 'We offer a suite of solutions to landlords seeking to create revenue generation opportunities from underutilized portions of their properties and developments.'},
                homeService4: {name: "We Buy", link: "/en/services/we-buy", subtitle: "Mergers and Acquisitions", description: 'Mergers and Acquisitions', description:"Whether it’s one or 1,000 towers, a metropolitan fiber network, or a portfolio of other digital infrastructure assets, we close deals quickly, and at competitive prices. For asset owners looking to generate income through partial or full portfolio sales, our M&A experts are committed to executing swift, fair transactions."},
                homeSection3: {title: 'Advanced Connectivity Requires Advanced Digital Infrastructure', content: 'In the Andean region, 4G and 5G technologies are defining the future of a networked society, where seamless connectivity is central to daily life.'},
                homeSection3Options: {options: [{name:'Our Portfolio', link: '/en/about/our-portfolio'},{name:'Small Cells', link: '/en/products/small-cells'},{name:'Our Vision for 5G', link: '/en/about/our-vision-for-5g'}]},
                homeSection4: {title: 'ATP’s Regional Presence', content1: 'ATP’s region-wide presence represents a significant competitive advantage. Through international sharing of systems, processes, and best-practices, our scale drives efficiency and customer value.', content2: 'Meanwhile, to ensure local agility, our team is divided into country-level operations. This structure delivers the benefits of scale, while leveraging a localized focus that allows us to respond faster to our clients’ dynamic digital infrastructure demands.', content3: 'We currently operate in:' },
                homeSection4Options: ['Chile', 'Colombia', 'Peru','Ecuador']
            },
            lenguageES: {
                sliderContent: {part1: 'Bienvenidos a', part2: 'Andean Telecom Partners', part3: 'Líder en Infraestructura Digital'},
                homeCard1: {link: '/es/productos/torres-y-azoteas',title: 'Torres y Micrositios', content: 'Construimos, administramos, adquirimos, desarrollamos y arrendamos infraestructura de telecomunicaciones a operadores móviles y otros proveedores de tecnología inalámbrica.'},
                homeCard2: {link: '/es/productos/fibra-optica',title: 'Fibra Óptica', content: 'Hemos iniciado operaciones de soluciones y servicios de fibra óptica en toda la región andina. Administramos, adquirimos, desarrollamos y arrendamos redes compartidas de fibra óptica, brindando servicios de capacidad y densificación.'},
                homeCard3: {link: '/es/productos/small-cells',title: 'Small Cells y DAS', content: 'Administramos, adquirimos, desarrollamos y arrendamos infraestructura de telecomunicaciones de Small Cells a operadores móviles. Nuestras soluciones son críticas para el proceso de densificación de redes 4G y 5G.'},
                subHome: 'Líder en <b> Soluciones y Servicios de Infraestructura Digital </b> para Redes de Conectividad Avanzada',
                subHomeDesc: 'Los operadores móviles, radiodifusoras, televisoras y desarrolladores de bienes raíces en la región andina cuentan con nuestro equipo de expertos para la expansión y densificación de sus redes. Si usted requiere formas de expandir o densificar su red, podemos ayudarlo.',
                homeService1: {name: "Arrendamos Espacio", link: "/es/services/arrendamos-espacio", subtitle: "Arriendo de Sitios", description: 'Con un portafolio de miles de sitios en la región andina, ofrecemos a los operadores móviles una variedad de ubicaciones y soluciones necesarias para expandir sus redes con servicios de co-ubicación.'},
                homeService2: {name: "Construimos", link: "/es/servicios/construimos", subtitle: "Desarrollo de Sitios & Redes", description: 'Hemos establecido una reputación sólida desarrollando y entregando sitios y redes de telecomunicaciones a tiempo, y dentro de presupuesto.'},
                homeService3: {name: "Administramos", link: "/es/servicios/administramos", subtitle: "Propiedades, edificios, inmobiliarios urbanos y espacios en azoteas", description: 'Ofrecemos oportunidades de ingreso adicional a los propietarios de bienes raíces en sus espacios y de bienes raíces sobre sus espacios subutilizados.'},
                homeService4: {name: "Compramos", link: "/es/servicios/compramos", subtitle: "Adquisiciones y Fusiones (M&A)", description: 'Mergers and Acquisitions', description: "Nos interesa evaluar portafolios diversos de infraestructura digital para adquirirlos. Nuestro proceso de valuación es rápido y ofrecemos precios competitivos. Si usted está considerando una venta parcial o completa de sus activos de infraestructura digital, contáctenos. Nuestros expertos de Adquisiciones y Fusiones están comprometidos a llevar a cabo una evaluación y transacción ágil."},
                homeSection3: {title: 'Conectividad Avanzada Requiere Infraestructura Digital Avanzada', content: 'En la región andina, las tecnologías 4G y 5G están definiendo el futuro de una sociedad conectada, dónde la estabilidad de las conexiones y el acceso continuo a la red son requisitos básicos de la vida cotidiana.'},
                homeSection3Options: {options: [{name:'Nuestro Portafolio', link: '/es/acerca-de-atp/nuestro-portafolio'},{name:'Small Cells', link: '/es/productos/small-cells'},{name:'Nuestra Visión 5G', link: '/es/acerca-de-atp/nuestra-vision-5g'}]},
                homeSection4: {title: 'Nuestra Presencia Regional', content1: 'La presencia regional de ATP nos posiciona con una capacidad única de poder ofrecer servicios y soluciones que traen las ventajas de economías de escala. Nuestro amplio portafolio rural y urbano nos permite responder rápidamente a la demanda de infraestructura digital.', content2: 'Actualmente operamos en:', content3: '' },
                homeSection4Options: ['Chile', 'Colombia', 'Perú','Ecuador']
            }
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    }
}
</script>

<style lang="scss" scoped>
    .carousel-all-ms{
        margin-top: 105px;
    }
</style>




// WEBPACK FOOTER //
// src/components/organisms/PmHome.vue